export class LogDetails {
  public id!: string;
  public message!: string;
  public userId!: string;

  public clientException!: string; // or should ClientException be a type
  public serverException!: string; // do i need this on client side or is it just an empty string?
  public LogLevel!: number; // or string
}
